'use client';
import React from 'react';
import { IconFeedback, IconUserCheck } from '@repo/svgs';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { Divider } from '@/components/ui/Divider';
import { DataCell } from '@/components/ui';
import { useBuilding } from '../../context/BuildingProvider';
import { cn } from '@/lib/cn';

export function BuildingRenterRecommendations() {
  const { aggResponse, isMasked } = useBuilding();

  return (
    <div className="flex flex-col w-full">
      {/* Section Header */}
      <SectionHeader title="Renter recommendations" />

      {/* Content */}
      <div className={cn('md:px-2')}>
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <DataCell
            icon={<IconFeedback className="w-6 h-6 icon-secondary" />}
            value={`${aggResponse?.recommendPerc ?? '-'}%`}
            description="Renters recommend this building"
            isMasked={isMasked}
          />

          <div className="flex items-center justify-center md:hidden py-1">
            <Divider />
          </div>

          <DataCell
            icon={<IconUserCheck className="w-6 h-6 icon-secondary" />}
            value={`${aggResponse?.approvePerc ?? '-'}%`}
            description="Renters approve of the building's owners"
            isMasked={isMasked}
          />
        </div>
      </div>
    </div>
  );
}
